export enum ListAliases {
  GeneralYesNo = 'general_yesno',
}
